import { Widget } from '../widget/widget.js';

export class RadioButtonWidget extends Widget {
    async validate(): Promise<boolean> {
        this.clearError();
        let valid = true;

        if (this.required && await this.getValue() === null) {
            this.displayError('widget.is_required');
            valid = false;
        }

        return valid;
    }

    async getValue(): Promise<string|boolean> {
        const $checkedRadio = this.$node.querySelector('input:checked');
        const boolean = 'boolean' in this.$node.dataset;
        const val = ($checkedRadio as HTMLInputElement)?.value ?? null;
        if (boolean) {
            return val === '1';
        }
        return val;
    }

    listen(action: string, fn: (e: Event) => void) {
        this.$node.querySelectorAll('input').forEach(i => i.addEventListener(action, fn));
    }
}
